/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import DashboardIcon from '@mui/icons-material/Dashboard';
import DnsIcon from '@mui/icons-material/Dns';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import SecurityIcon from '@mui/icons-material/Security';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import ReplayIcon from '@mui/icons-material/Replay';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupIcon from '@mui/icons-material/Group';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import HiveIcon from '@mui/icons-material/Hive';
import HelpIcon from '@mui/icons-material/Help';
import SupportIcon from '@mui/icons-material/Support';
import TollIcon from '@mui/icons-material/Toll';
import CloudIcon from '@mui/icons-material/Cloud';

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <Link
            className="md:block text-center md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-lg font-bold1 p-1 px-0"
            to="/"
          >
            AutomateCIS
          </Link>
          {/* User */}
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-center md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-lg font-bold1 p-4 px-0"
                    to="/"
                  >
                    AutomateCIS
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <hr className="my-1 md:min-w-full" />
            {/* Form */}
            <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 px-3 py-2 h-12 border border-solid  border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
            </form>
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/dashboard") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/dashboard"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><DashboardIcon fontSize="small" /></i>{" "}
                  Dashboard
                </Link>
              </li>
                <h3 style={{
                  alignItems: "center",
                  float: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  marginTop: "10px"
                }}>INSTANCE</h3> 
              <hr className="mb-2 md:min-w-full" />
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/hostmanagement") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/hostmanagement"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/hostmanagement") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><DnsIcon fontSize="small" /></i>{" "}
                  Manage Host
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/cloudmanagement") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/cloudmanagement"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/cloudmanagement") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><CloudIcon fontSize="small" /></i>{" "}
                  Manage Cloud
                </Link>
              </li>              
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/jumphostmanagement") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/jumphostmanagement"
                >  
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/jumphostmanagement") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><ViewAgendaIcon fontSize="small" /></i>{" "}
                  Jump Host
                </Link>
              </li>  
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/credentials") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/credentials"
                > 
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/credentials") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><VpnKeyIcon fontSize="small" /></i>{" "}
                  Credentials
                </Link>
              </li>      
            </ul>
            <h3 style={{
                  alignItems: "center",
                  float: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  marginTop: "10px"
                }}>ANALYSIS</h3> 
              <hr className="mb-2 md:min-w-full" />
              {/* <div> */}
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/runauditmanager") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/runauditmanager"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/runauditmanager") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><HiveIcon fontSize="small" /></i>{" "}
                  
                  Run Audit
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/profile") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/profile"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/profile") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><MenuBookIcon fontSize="small" /></i>{" "}
                  Profile
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/scheduling") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/scheduling"
                >
                  <i
                    className={
                     "mr-2 text-sm" +
                      (window.location.href.indexOf("/admin/scheduling") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ><AccessTimeFilledIcon fontSize="small" /></i>{" "}
                  Schedule
                </Link>
              </li>          
            </ul>
            <h3 style={{
                  alignItems: "center",
                  float: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  marginTop: "10px"
                }}>RESOURCE
            </h3> 
              <hr className="mb-2 md:min-w-full" />
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-sm  px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/audit") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/audit"
                >
                  <i className=" mr-2 text-sm"><SecurityIcon fontSize="small" /></i>{" "}
                  Audit
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/remedy") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }
                  to="/admin/remedy"
                >
                  <i className="mr-2 text-sm"><BeenhereIcon fontSize="small" /></i>{" "}
                  Remedy
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/rollback") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }                
                  to="/admin/rollback"
                >
                  <i className="mr-2 text-sm"><ReplayIcon fontSize="small" /></i>{" "}
                  Rollback
                </Link>
              </li>
            </ul>  
            <h3 style={{
                  alignItems: "center",
                  float: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  marginTop: "10px"
                }}>MANAGEMENT
            </h3> 
              <hr className="mb-2 md:min-w-full" />
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block " +
                    (window.location.href.indexOf("/admin/usermanager") !== -1
                      ? "text-lightBlue-500 hover:text-lightBlue-600"
                      : "text-blueGray-500 hover:text-blueGray-500")
                  }                  
                  to="/admin/usermanager"
                >
                  <i className="mr-2 text-sm"><GroupAddIcon fontSize="small" /></i>{" "}
                  Users
                </Link>
              </li>
              <li className="items-center">
                <Link
                 className={
                  "text-sm px-3 py-2 font-bold block " +
                  (window.location.href.indexOf("/admin/groupmanager") !== -1
                    ? "text-lightBlue-500 hover:text-lightBlue-600"
                    : "text-blueGray-500 hover:text-blueGray-500")
                }                  
                  to="/admin/groupmanager"
                >
                  <i className="mr-2 text-sm"><GroupIcon fontSize="small" /></i>{" "}
                  Groups
                </Link>
              </li>
              <li className="items-center">
                <Link
                 className={
                  "text-sm px-3 py-2 font-bold block " +
                  (window.location.href.indexOf("/admin/license") !== -1
                    ? "text-lightBlue-500 hover:text-lightBlue-600"
                    : "text-blueGray-500 hover:text-blueGray-500")
                }                  
                  to="/admin/license"
                >
                  <i className="mr-2 text-sm"><TollIcon fontSize="small" /></i>{" "}
                  License
                </Link>
              </li>              
            </ul>   
            <h3 style={{
                  alignItems: "center",
                  float: "center",
                  fontSize: "11px",
                  fontWeight: 700,
                  marginTop: "10px"
                }}>HELP</h3> 
              <hr className="mb-2 md:min-w-full" />
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block text-blueGray-500 hover:text-blueGray-500"
                  }
                  to="/support"
                  target="blank"
                >
                  <i
                    className={
                     "mr-2 text-sm opacity-75"
                    }
                  ><SupportIcon fontSize="small" /></i>{" "}
                  
                  Support
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-sm px-3 py-2 font-bold block text-blueGray-500 hover:text-blueGray-500"
                  }
                  to="/docs"
                  target="blank"
                >
                  <i
                    className={
                     "mr-2 text-sm opacity-75"
                    }
                  ><HelpIcon fontSize="small" /></i>{" "}
                  Docs
                </Link>
              </li>         
            </ul>            
          </div>
        </div>
      </nav>
    </>
  );
}
